module.exports = __webpack_public_path__ + "img/right.fe755941.png";